function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m264.568 56.385-173.309 105.263h-36.259c-30.327 0-55 24.673-55 55v78.719c0 30.327 24.673 55 55 55h29.262c.044.026.085.056.13.082l180.549 105.405c16.535 9.653 37.604-2.237 37.604-21.59v-356.512c0-19.459-21.344-31.471-37.977-21.367zm-234.568 238.981v-78.719c0-13.785 11.215-25 25-25h21.955v128.719h-21.955c-13.785 0-25-11.214-25-25zm242.545 130.188-165.591-96.672v-141.667l165.591-100.576z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m349.526 317.936c-8.284 0-15 6.716-15 15s6.716 15 15 15c50.69 0 91.929-41.239 91.929-91.929s-41.239-91.929-91.929-91.929c-8.284 0-15 6.716-15 15s6.716 15 15 15c34.148 0 61.929 27.781 61.929 61.929s-27.781 61.929-61.929 61.929z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m349.526 93.533c-8.284 0-15 6.716-15 15s6.716 15 15 15c73.046 0 132.474 59.427 132.474 132.474s-59.428 132.475-132.474 132.475c-8.284 0-15 6.716-15 15s6.716 15 15 15c89.588 0 162.474-72.886 162.474-162.475s-72.886-162.474-162.474-162.474z"
}));

var SvgVolume = function SvgVolume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume.b7b832af.svg";
export { ForwardRef as ReactComponent };